// extracted by mini-css-extract-plugin
module.exports = {"enOfertaContainer":"EnOfertaSpan_enOfertaContainer__2bzH0","enOfertaAnimation":"EnOfertaSpan_enOfertaAnimation__1rTy6","bottom":"EnOfertaSpan_bottom__437ZS"};